const gamePid = {
	agLive: {
		pid: '84',
		TransferID: '84',
		title: 'AG真人',
	},
	kyChess: {
		pid: '44',
		TransferID: '44',
		title: '开元棋牌',
	},
	// ylChess: {
	// 	pid: '247',
	// 	TransferID: '247',
	// 	title: '优乐棋牌',
	// },
	lyChess: {
		pid: '125',
		TransferID: '125',
		title: 'LEG_乐游棋牌',
	},
	bgLive: {
		pid: '43',
		TransferID: '43',
		title: 'BG真人_BG渠道',
	},
	yoplaySlot: {
		pid: '87',
		TransferID: '84',
		title: 'YOPLAY电子',
	},
	agFish: {
		pid: '86',
		TransferID: '84',
		title: 'AG捕鱼王',
	},
	hgSport: {
		pid: '167',
		TransferID: '167',
		title: '皇冠体育',
	},
	xinSlot: {
		pid: '85',
		TransferID: '84',
		title: 'XIN老虎机',
	},
	bbinLive: {
		pid: '39',
		TransferID: '39',
		title: 'BBIN真人',
	},
	igSsc: {
		pid: '54',
		TransferID: '52',
		title: 'IG彩票时时彩',
	},
	mgSlot: {
		pid: '42',
		TransferID: '42',
		title: 'MG电子',
	},
	sbSport: {
		pid: '41',
		TransferID: '41',
		title: '沙巴体育',
	},
	saLive: {
		pid: '38',
		TransferID: '38',
		title: 'SA真人',
	},
	SEXYLive: {
		pid: '238',
		TransferID: '238',
		title: 'SEXY真人',
	},
	bbinSlot: {
		pid: '46',
		TransferID: '39',
		title: 'BBIN电子',
	},
	ptSlot: {
		pid: '83',
		TransferID: '83',
		title: 'PT老虎机',
	},
	lcChess: {
		pid: '126',
		TransferID: '126',
		title: '凯旋棋牌',
	},
	igGfc: {
		pid: '52',
		TransferID: '52',
		title: 'IG彩票官方彩',
	},
	cq9Slot: {
		pid: '88',
		TransferID: '88',
		title: 'CQ9电子_CQ9',
	},
	TSbr: {
		pid: '94',
		TransferID: '94',
		title: 'TS_裸体百家乐',
	},
	bbinSport: {
		pid: '40',
		TransferID: '39',
		title: 'BBIN体育',
	},
	igXgc: {
		pid: '53',
		TransferID: '52',
		title: 'IG彩票香港彩',
	},
	oldhgSport: {
		pid: '35',
		TransferID: '35',
		title: '皇冠体育_旧',
	},
	imSlot:{
		pid: '441',
		TransferID: '441',
		title: 'IM电竞',
	}
};
let game = [
	{
		type: 1,
		name: '真人',
		path: 'live',
		img: 'zr',
		list: [
			{
				name: 'AG',
				pid: gamePid.agLive.pid,
				TransferID: gamePid.agLive.TransferID,
				show: true,
				gametype: '0',
				list: [],
			},
			{
				name: 'BBIN',
				gametype: '0',
				pid: gamePid.bbinLive.pid,
				TransferID: gamePid.bbinLive.TransferID,
				show: true,
				list: [],
			},
			{
				name: 'BG',
				gametype: '0',
				pid: gamePid.bgLive.pid,
				TransferID: gamePid.bgLive.TransferID,
				show: true,
				list: [],
			},
			{
				name: 'SA',
				show: true,
				gametype: '0',
				pid: gamePid.saLive.pid,
				TransferID: gamePid.saLive.TransferID,
				list: [],
			},

			// {
			// 	name: 'SEXY',
			// 	show: true,
			// 	gametype: '0',
			// 	pid: gamePid.SEXYLive.pid,
			// 	TransferID: gamePid.SEXYLive.TransferID,
			// 	list: [],
			// },
		],
	},
	{
		type:7,
		name: '电竞',
		path: 'im',
		img: 'im',
		list: [
			{
				name: 'IM',
				pid: gamePid.imSlot.pid,
				TransferID: gamePid.imSlot.TransferID,
				show: true,
				gametype: '0',
				list: [],
			}
		],
	},
	{
		type: 2, //el
		name: '电子',
		path: 'slot',
		img: 'dz',
		list: [
			//el2
			{
				name: 'PT',
				show: true,
				pid: gamePid.ptSlot.pid,
				TransferID: gamePid.ptSlot.TransferID,
				list: [],
			},
			// {
			// 	name: 'CQ9',
			// 	show: true,
			// 	pid: gamePid.cq9Slot.pid,
			// 	TransferID: gamePid.cq9Slot.TransferID,
			// 	list: [],
			// },
			{
				name: 'XIN',
				show: true,
				pid: gamePid.xinSlot.pid,
				TransferID: gamePid.xinSlot.TransferID,
				list: [],
			},
			{
				name: 'YOPLAY',
				pid: gamePid.yoplaySlot.pid,
				TransferID: gamePid.yoplaySlot.TransferID,
				show: true,
				list: [],
			},

			{
				name: 'MG',
				show: true,
				pid: gamePid.mgSlot.pid,
				TransferID: gamePid.mgSlot.TransferID,
				list: [],
			},
			{
				name: 'BBIN',
				show: true,
				pid: gamePid.bbinSlot.pid,
				TransferID: gamePid.bbinSlot.TransferID,
				list: [],
			},
		],
	},
	{
		type: 3,
		name: '体育',
		path: 'sport',
		img: 'ty',
		list: [
			{
				name: '沙巴体育',
				pid: gamePid.sbSport.pid,
				TransferID: gamePid.sbSport.TransferID,
				show: true,
				list: [],
			},
			{
				name: 'BBIN体育',
				pid: gamePid.bbinSport.pid,
				TransferID: gamePid.bbinSport.TransferID,
				show: true,
				list: [],
			},
			{
				name: '皇冠体育',
				pid: gamePid.hgSport.pid,
				TransferID: gamePid.hgSport.TransferID,
				show: true,
				list: [],
			},
		],
	},
	{
		type: 5,
		name: '彩票',
		path: 'lottery',
		img: 'cp',
		list: [
			{
				name: 'IG时时彩',
				pid: gamePid.igSsc.pid,
				TransferID: gamePid.igSsc.TransferID,
				show: true,
				list: [],
			},
			{
				name: 'IG香港彩',
				pid: gamePid.igXgc.pid,
				TransferID: gamePid.igXgc.TransferID,
				show: true,
				list: [],
			},
			{
				name: 'IG官方彩',
				pid: gamePid.igGfc.pid,
				TransferID: gamePid.igGfc.TransferID,
				show: true,
				list: [],
			},
		],
	},
	{
		type: 4,
		name: '棋牌',
		path: 'chess',
		img: 'qp',
		list: [
			{
				name: '开元棋牌',
				pid: gamePid.kyChess.pid,
				TransferID: gamePid.kyChess.TransferID,
				gametype: '0',
				show: true,
				list: [],
			},
			// {
			// 	name: '优乐棋牌',
			// 	pid: gamePid.ylChess.pid,
			// 	TransferID: gamePid.ylChess.TransferID,
			// 	gametype: '0',
			// 	show: true,
			// 	list: [],
			// },
			{
				name: '乐游棋牌',
				pid: gamePid.lyChess.pid,
				TransferID: gamePid.lyChess.TransferID,
				gametype: '0',
				show: true,
				list: [],
			},
			{
				name: '凯旋棋牌',
				pid: gamePid.lcChess.pid,
				TransferID: gamePid.lcChess.TransferID,
				gametype: '0',
				show: true,
				list: [],
			},
		],
	},
	{
		type: 6,
		name: '捕鱼',
		path: 'fishing',
		img: 'by',
		list: [
			{
				name: 'AG捕鱼王',
				pid: gamePid.agFish.pid,
				TransferID: gamePid.agFish.TransferID,
				show: true,
				list: [],
			},
		],
	},
];
// game.map((el, i) => {
// 	el.list.map((el2, j) => {
// 		el2.img = require(`@/assets/img/game/${el.img}/${j + 1}.png`);
// 		if (el2.path == 'fishing') {
// 			//只有一级
// 			el2.oneUrl = require(`@/assets/img/game/${el.img}/by-1.png`);
// 		}
// 		// el2.list &&
// 		// 	el2.list.map((el3, k) => {
// 		// 		el3.img = `/static/game/${el.img}/${el2.name}/${k + 1}.png`;
// 		// 	});
// 	});
// });

export default { game, gamePid };
